<template>
     <div  v-show="showForm">
         <slot :scope="scope"></slot>
     </div>
</template>
<script>
export default {
    name: 'LayuiForm',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-form-' + window.uuid();
            },
        },
        defaultValue: {
            type: Object,
            default: () => {
                return {};
            }
        },
        //用于表单新增的时候，如果数据是新增的，那么该属性的值会作为默认值存入数据库
        initValue: {
            type: Function,
        },
        afterSave: {
            type: Function,
            default: () => {
                return new Function();
            }
        },
        rule: {
            type: Object,
            default: () => {
                return {};
            }
        },
        showForm: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        /**
         * 组件是否用于 layui-body 容器外部
         * - 用于解决弹窗不显示问题
         * - 类型为 DOM 对象或者 JQuery 对象的选择器
         */
        outside: { type: String }
    },
    data() {
        return {
            id: null,
            editRow: this.initValue ? this.initValue() : {_SLAVE : {}},
            scope: this
        }
    },
    mounted() {
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        element.attr('id', id);
    },
    methods: {
        isInsert() {
            return this.editRow['IS_NEW'] == undefined || this.editRow['IS_NEW'] == true;
        },
        // 用小弹窗打开form表单
        open(title, width, height, colseCB, targetEl, conf = {}) {
            this.resetValidate();
            this.layer.openPop(this.id,  title, width, height, null, colseCB, targetEl || (this.outside && $(this.outside)), conf);
        },
        // 用大弹窗铺满屏幕打开form表单
        openWin(title, colseCB, targetEl) {
            this.resetValidate();
            this.layer.openWin(this.id, title, colseCB, targetEl || (this.outside && $(this.outside)));
        },
        openPopRight(width,height,colseCB, targetEl, title){
            this.resetValidate();
            this.layer.openPopRight(this.id, width, height, colseCB, targetEl || (this.outside && $(this.outside)), title);
        },
        // 关闭form表单
        close() {
            this.layer.closePop(this.id)
        },
        setEditRow(row) {
            this.editRow = $.extend(true,{}, row);
            if(this.isInsert()){
                this.editRow = $.extend(true,this.editRow, this.defaultValue);
                if(!this.editRow._SLAVE) {
                    this.editRow._SLAVE = {};
                }

                 // 派发新增事件
                this.$emit('insertEvent', this.editRow);
            } else {
                // 派发编辑事件
                this.$emit('editEvent', this.editRow);
            }
        },
        // 根据key和value设置defaultValue
        setDefaultValue(key, value){
            this.defaultValue[key] = value;
            return this;
        },
        setAfterSave(cb) {
            this.afterSave = cb;
        },
        resetValidate() {
            this.el.find('.rulemessage').remove();
            this.el.find('.layui-input-inline').css('border', '1px  #D2D2D2').css('border-radius', '0px');;
        },
        // 校验form表单
        validate() {
            var result = true;
            for(var field in this.rule) {
                var ruleItem = this.rule[field];
                var fieldValidate = true;
                //var targetEl = this.el.find('[name=' + field + ']').parents('.layui-input-inline').first();
                var targetEl = this.el.find('[name=' + field + ']').first();
                var errorArr = [];
                //校验可选项 true不校验 false 校验
                if (ruleItem.optional) continue;
                for(var ruleName in ruleItem) {
                    var ruleParam = ruleItem[ruleName];
                    var ruleMethod = this.ruleObj.getRuleMethod(ruleName);
                    if(ruleMethod) {
                        if(!ruleMethod(ruleItem['field'] ? ruleItem['field'] : field, this.editRow, ruleParam)) {
                            fieldValidate = false;
                            result = false;
                            var message = ruleParam.message;
                            if(targetEl.length > 0){
                                targetEl.addClass('layui-form-danger').focus();
                                //如果是layui-select,那么需要找到input
                                targetEl.find('input').addClass('layui-form-danger').focus();
                                targetEl.find('.xm-select').addClass('layui-form-danger').focus();
                                layer.msg(message, {icon: 5,shift: 6, targetEl: (this.outside && $(this.outside))})
                                errorArr.push(targetEl)
                            }
                        }
                    }
                }
                // 解决 校验定位
                if (errorArr.length > 0) {
                  errorArr[0].focus();
                  return
                }
                if(fieldValidate) {
                    // targetEl.css('border', '1px  #D2D2D2').css('border-radius', '0px');;
                    // targetEl.find('.rulemessage').remove();
                    targetEl.siblings().remove();
                }
            }
            return result;
        },
        save(table, reload, sucCb, failCb) {
            if(this.validate()) {
              if (typeof table === 'string') {
                this.api.save(table, this.editRow, this.requestUniqueId).then(response => {
                    if(response.errorMsg) {
                        this.layer.openAlert(response.errorMsg, false, undefined, { targetEl: (this.outside && $(this.outside)) });
                        typeof failCb === 'function' && failCb({ type: 'error', data: response })
                    } else {
                        this.layer.openSuccess('保存成功!', { targetEl: (this.outside && $(this.outside)) });
                        // table.pageInfo.pageIndex = 1;
                        // table.load();

                        typeof sucCb === 'function' && sucCb({ type: 'success', data: response })
                        this.$bus.$emit(reload)
                        this.close();
                    }
                });
              } else {
                this.api.save(table.getTableName(), this.editRow, this.requestUniqueId).then(response => {
                    if(response.errorMsg) {
                        this.layer.openAlert(response.errorMsg, false, undefined, { targetEl: (this.outside && $(this.outside))});
                        typeof failCb === 'function' && failCb({ type: 'error', data: response })
                   } else {
                        this.layer.openSuccess('保存成功!', { targetEl: (this.outside && $(this.outside))});
                        table.pageInfo.pageIndex = 1;

                        typeof sucCb === 'function' && sucCb({ type: 'success', data: response })
                        table.load();
                        this.close();
                    }
                });
              }
            } else {
              // 校验不通过
              typeof failCb === 'function' && failCb({ type: 'validate' })
            }
        },
        saveCallback(table, config) {
            config = config ? config : {};
            if(this.validate()) {
                if(config.showLoading) {
                     this.layui.layer.load(2);
                }
                this.api.save(table.getTableName(), this.editRow, this.requestUniqueId).then(response => {
                    if(config.showLoading) {
                        this.layer.closeLoading();
                    }
                    if(response.errorMsg) {
                        if(config.error){
                            config.error(response);
                        } else {
                            this.layer.openAlert(response.errorMsg, false);
                        }
                    } else {
                        if(config.success){
                            config.success(response);
                        } else {
                            this.layer.openSuccess('保存成功!');
                            table.pageInfo.pageIndex = 1;
                            table.load();
                            this.close();
                        }
                    }
                });
            }
        },
        callableSave(table, showLoading,isValidate=true) {
            //校验通过标识
            let valid = true;
            if(isValidate){
                if (!this.validate()) {
                    valid = false;
                }
            }
            if(valid) {
                //如果传入的是table对象，就通过getTableName方法获得表名称,否则人为table就是表名
                if(showLoading) {
                        this.layui.layer.load(2, { targetEl: (this.outside && $(this.outside))});
                }
                this.api.save(table.getTableName ? table.getTableName() : table, this.editRow, this.requestUniqueId).then(response => {
                    if(showLoading) {
                        this.layer.closeLoading();
                    }
                    if(response.errorMsg) {
                        this.layer.openAlert(response.errorMsg, false, undefined, { targetEl: (this.outside && $(this.outside))});
                    } else if(this.afterSave) {
                        this.afterSave(response.result, this.isInsert());
                    }
                });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiForm.vue